import T from "@mui/icons-material/Done";
import { styled as e, Box as s, Checkbox as A, Typography as F } from "@mui/material";
import I from "@mui/material/FormControlLabel";
import L from "../../../temp-lib/components/account/share/EmailTextField.js";
import N from "../../../temp-lib/components/account/share/ForgotPasswordButton.js";
import R from "../../../temp-lib/components/account/share/PasswordTextField.js";
import M from "../../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import { ERROR_CODE as _ } from "../../../temp-lib/constants/error.js";
import { useAccountContext as V } from "../../../temp-lib/contexts/account/AccountContext.js";
import { useGeetest4Context as G } from "../../../temp-lib/contexts/account/Geetest4Context.js";
import { useMessageContext as P } from "../../../temp-lib/contexts/share/MessageContext.js";
import { CustomError as j } from "../../../temp-lib/errors/customError.js";
import * as D from "ramda";
import { useState as x, useCallback as a, useEffect as z } from "react";
import { useForm as U } from "react-hook-form";
import { useTranslation as W } from "react-i18next";
import { jsx as o, jsxs as b } from "react/jsx-runtime";
const $ = e(s)`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  position: relative;
`, q = e("form")`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`, H = e(A)`
  > .MuiSvgIcon-root {
    background-color: black;
  }
  > .Mui-checked {
    color: black;
    :before {
      background-image: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath"+
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")";
    }
  }
  ${(n) => n.theme.breakpoints.down("res768")} {
    margin-left: 10px;
  }
`, J = e(s)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`, K = e(F)`
  color: #ff0000;
  width: 100%;
  height: 20px;
`, Q = e(s)`
  width: 100%;
  height: 20px;
`, X = e(M)`
  --background-color: white;

  border-radius: 4px;
  color: black;
  font-size: 20px;
  font-weight: 700;
  height: 50px;
  margin-left: auto;
  text-transform: uppercase;
  width: 100%;
`, ho = (n) => {
  const {
    className: w
  } = n, {
    t
  } = W(), [C, r] = x(!1), [k, l] = x(!0), {
    doGeetest: c
  } = G(), {
    loginByEmail: m
  } = V(), {
    setSnackInfo: d
  } = P(), {
    control: g,
    formState: p,
    handleSubmit: y,
    reset: f
  } = U({
    mode: "onChange"
  }), h = a(() => {
    r(!1);
  }, []), E = a((i) => {
    l(i.target.checked);
  }, []), v = a(async (i) => {
    const {
      email: B,
      password: O
    } = i;
    c(async (S) => {
      try {
        const u = await m({
          email: B,
          password: O,
          geeTest: S
        });
        if (D.isNil(u))
          throw new j("cannot get account response", _.LOGIN.CANNOT_GET_ACCOUNT_RESPONSE);
        d({
          message: t("login.general.login_success"),
          serverity: "success"
        });
      } catch {
        r(!0);
      }
    });
  }, [c, m, d, t]);
  return z(() => {
    f({
      email: "",
      password: ""
    }), l(!1), r(!1);
  }, [f]), /* @__PURE__ */ o($, {
    className: w,
    children: /* @__PURE__ */ b(q, {
      onSubmit: y(v),
      children: [/* @__PURE__ */ o(L, {
        control: g,
        enableValidation: !0,
        name: "email",
        onChange: h
      }), /* @__PURE__ */ o(R, {
        control: g,
        enableValidation: !0,
        name: "password",
        onChange: h
      }), /* @__PURE__ */ b(J, {
        children: [/* @__PURE__ */ o(I, {
          control: /* @__PURE__ */ o(H, {
            checked: k,
            onChange: E,
            checkedIcon: /* @__PURE__ */ o(T, {
              sx: {
                color: "white"
              }
            })
          }),
          label: t("login.email.rememberBox")
        }), /* @__PURE__ */ o(N, {})]
      }), C ? /* @__PURE__ */ o(K, {
        children: t("login.email.validation.wrong_input")
      }) : /* @__PURE__ */ o(Q, {}), /* @__PURE__ */ o(X, {
        disabled: !p.isDirty || !p.isValid,
        type: "submit",
        children: t("login.email.button.signIn")
      })]
    })
  });
};
export {
  ho as default
};
//# sourceMappingURL=EmailLoginComponent.js.map
